import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout, Header } from 'app/theme/layout'
import ImageHero from 'app/theme/ImageHero'
import NavbarFixed from 'app/theme/NavbarFixed'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import styles from './EventGuarantee.module.css'
import hero from 'assets/img/event-guarantee-1.jpg'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'

export default function EventGuarantee() {
  const { openModal, ...modalState } = useModalState()

  const navMenu = [
    {
      title: 'Community Events',
      url: '/food-truck-catering/local-community-concessions/',
    },
    {
      title: '100% Roaming Hunger Event Guarantee',
      url: '/food-truck-catering/community-concessions-event-guarantee/',
      active: true,
    },
    {
      title: 'Food Trucks For Bars, Breweries, and Wineries',
      url: '/food-truck-catering/food-trucks-for-bars-breweries-wineries/',
    }
  ]

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>
          Roaming Hunger Event Guarantee - Community Event Concessions - Roaming
          Hunger
        </title>
        <meta
          name="description"
          content="If you’re looking to secure a food truck to sell food to your event attendees, we can take care of the entire process."
        />
        <meta
          name="og:title"
          content="Roaming Hunger Event Guarantee - Community Event Concessions"
        />
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <ImageHero
        imageUrl={hero}
        title="Local Community Events"
        description="100% Roaming Hunger Event Guarantee"
        onButtonClick={openModal}
      />
      <NavbarFixed menuItems={navMenu} />
      <div className="container text-gray-900">
        <h2 className="text-center text-navy text-4xl font-platform leading-tight md:leading-normal mt-10 mb-10">
          100% Roaming Hunger Event Guarantee
        </h2>
        <p className="md:text-base text-lg font-light">
          Here’s how the Roaming Hunger Event Guarantee works: If you’re looking
          to secure a food truck to sell food to your event attendees, we can
          take care of the entire process.
        </p>
        <p className="md:text-base text-lg font-light mb-4">
          For a service charge, working with us includes the following:
          <ul className="text-gray-900 font-light list-inside list-disc mb-2 mt-0">
            <li>
              A personal consultation to make sure we find the right food trucks
              or carts for your event.
            </li>
            <li>Securing a reliable and delicious food truck.</li>
            <li>
              Assistance in making sure the proper permits, insurance, and
              secure contracts are in place.
            </li>
            <li>Replacing a food truck in case of cancellation.</li>
            <li>
              Our signature 100% money-back guarantee. If we cannot find an
              available food truck for your event, we'll refund you 100% of the
              service charge.
            </li>
          </ul>
        </p>
        <h3 className="text-navy text-2xl mt-4 mb-2">Common Questions</h3>
        <strong>When does the 100% money-back guarantee apply?</strong>
        <p className="md:text-base text-lg font-light mb-4">
          The service charge for hiring Roaming Hunger is to help you secure a
          food truck, or multiple food trucks, to sell food at your event. In
          some instances a food truck may not be available in your area. If
          you’ve paid us a service charge and we cannot find any food trucks
          that fit your needs, we will refund you the service charge plus an
          extra 20%. The 100% money-back guarantee does not apply if the event
          is cancelled or changes, or if you refuse to accept the food truck
          options we provide.
        </p>
        <strong>
          How do I submit a 100% Roaming Hunger Event Guarantee refund request?
        </strong>
        <p className="md:text-base text-lg font-light mb-4">
          Just contact your Roaming Hunger Agent who will get the process
          started and tell you when you can expect the refund.
        </p>
        <strong>
          How long will it take for my refund request to be processed?
        </strong>
        <p className="md:text-base text-lg font-light mb-4">
          You should receive your refund within 30 days of the request. The
          payment is generally submitted through our accounting department to a
          third party (bank), who then issues the refund.
        </p>
        <strong>Is the 100% Roaming Hunger Service Guarantee different?</strong>
        <p className="md:text-base text-lg font-light mb-4">
          Yes, our 100% Roaming Hunger Service Guarantee is for food truck
          catering, which applies to events where the host pays for the food
          truck (not the attendees). To learn more go{' '}
          <a
            className="text-blue-100"
            href="/food-truck-catering/roaming-hunger-guarantee/"
          >
            here
          </a>
          .
        </p>
      </div>
      <OccasionsSlider
        className="bg-white py-12 mt-10"
        heading="Other catering occasions"
      />
    </Layout>
  )
}
